






import Navbar from '@/components/ui/Navbar.vue';
import Vue from 'vue'
export default Vue.extend({
  components: { Navbar }
})
